import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label: string;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  href = '#comprar',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-sm sm:px-10 sm:py-5 sm:text-base' : 'px-6 py-3 text-sm';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#') || href === '#') return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded bg-[#16a34a] font-bold uppercase tracking-[0.08em] text-white shadow-[0_10px_30px_-12px_rgba(22,163,74,0.9)] transition-colors duration-200 hover:bg-[#22c55e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#22c55e] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f172a] ${sizing} ${className}`} style={{
    paddingLeft: "65px",
    paddingRight: "17px"
  }} data-id="element-178" data-mp="1h5jn9manpv2p">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-179" data-mp="2qggegl3snerh" />
    </a>;
}